import React from 'react'
import clsx from 'clsx'
import { withStyles,withTheme } from '@material-ui/core/styles'

import {NavFooterSchema, FooterCollapsed} from '../../../services/NavFooterSchema'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const FooterStyle = theme => ({
    appFooter: {
        ...theme.globals.appFooter,
        ...{
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            width: '100%',
            boxSizing: 'border-box',
            zIndex: 1000,
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
    },
    // Nuova classe per quando vogliamo il footer fisso (default attuale)
    footerFixed: {
        position: 'fixed',
        bottom: 0,
        left: 0,
    },
    // Nuova classe per quando vogliamo il footer nel flusso normale
    footerStatic: {
        position: 'relative',
    },
    toggleButton: {
        color: 'inherit',
        padding: 0,
        marginLeft: theme.spacing(1),
    },
    footerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    footerCollapsedContainer: {
        width: '100%',
    },
    footerCenter: {textAlign:'center'},
    footerLeft: {
        textAlign:'left',
        [theme.breakpoints.down('sm')]: {
            textAlign:'center',
        },
    },
})

class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isExpanded: false
        }
    }

    toggleExpansion = () => {
        this.setState(prevState => ({ isExpanded: !prevState.isExpanded }))
    }

    renderItems() {
        return NavFooterSchema.map((item,i) => {
            const text = item.text
            const lg = item.hasOwnProperty('xs') ? item.xs : (
                this.props.hasOwnProperty('itemXs') ? this.props.itemXs : null
            )

            return <Grid item xs={12} md={lg} key={"app-footer-item-"+i}>
                {text}
            </Grid>
        })
    }
    render() {
        const { classes } = this.props
        const containerSize = this.props.hasOwnProperty('containerSize')
            ? this.props.containerSize
            : "xl"
        const textAlign = this.props.hasOwnProperty('textAlign')
            ? this.props.textAlign
            : "left"
        const position = this.props.position ? this.props.position : "fixed"
        const footerClasses = clsx(
            textAlign === 'center' ? classes.footerCenter : classes.footerLeft,
            classes.appFooter,
            position === 'fixed' ? classes.footerFixed : classes.footerStatic,
            this.props.hasOwnProperty('className') ? this.props.className : ""
        )
        const customStyle = this.props.hasOwnProperty('customStyle')
            ? this.props.customStyle
            : {}

        const FooterCollapsedComp = FooterCollapsed || null

        return <footer id="Footer" className={footerClasses} style={customStyle}>
            {FooterCollapsedComp 
                ? <Collapse in={this.state.isExpanded} timeout="auto" unmountOnExit className={classes.footerCollapsedContainer}>
                    {FooterCollapsedComp}
                </Collapse>
                : null
            }
            <Container maxWidth={containerSize}>
                <Grid container alignItems="center" wrap="nowrap" className={classes.footerContent}>
                    <Grid item xs style={{ minWidth: 0 }}>
                        <Grid container spacing={2} alignItems="center">
                            {this.renderItems()}
                        </Grid>
                    </Grid>
                    {FooterCollapsedComp && (
                        <Grid item>
                            <IconButton 
                                onClick={this.toggleExpansion} 
                                className={classes.toggleButton}
                                size="small"
                                aria-label="espandi footer"
                            >
                                {this.state.isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Grid>
                    )}
                </Grid>
            </Container>
        </footer>
    }
}

export default withStyles(FooterStyle)(withTheme(Footer))